import type { ReactNode, FC } from "react";
import { motion } from "framer-motion";
import { cn } from "@/utils/cn";

interface MobilePageNavTab {
  id: string;
  label: string;
  icon: ReactNode;
}

interface PageNavProps {
  tabs: readonly MobilePageNavTab[];
  activeSection: string;
  onTabClick: (id: string) => void;
}

export const MobileNavbar: FC<PageNavProps> = ({ tabs, activeSection, onTabClick }) => (
  <div className="relative z-9999 w-screen">
    <div className="flex items-center justify-center">
      <div className="fixed bottom-10 z-9999 md:hidden">
        <motion.div
          initial={{ opacity: 0, y: -120 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 120 }}
          transition={{ duration: 1.6, delay: 0.9, type: "spring" }}
          className="max-w-4xl"
        >
          <div className="sticky top-0 z-50 flex space-x-4 rounded-3xl bg-secondary px-1 py-[3px] shadow-secondary drop-shadow-md backdrop-blur-sm">
            <ul className="flex w-full justify-between">
              {tabs.map((tab) => {
                const isActive = tab.id === activeSection;
                return (
                  <motion.button
                    key={tab.id}
                    onClick={() => onTabClick(tab.id)}
                    className="relative flex cursor-pointer items-center justify-center px-4 py-2 text-lg font-medium outline-hidden transition focus-visible:outline-2"
                    style={{ WebkitTapHighlightColor: "transparent" }}
                  >
                    {isActive && (
                      <motion.div
                        layoutId="m-nav-highlight"
                        className="absolute inset-0 bg-secondary"
                        style={{ borderRadius: 9999 }}
                        transition={{ type: "tween", duration: 0.3 }}
                      />
                    )}
                    <div
                      className={cn(
                        "z-20 flex h-6 w-6 items-center",
                        isActive ? "text-white" : "text-slate-100/70",
                      )}
                    >
                      {tab.icon}
                    </div>
                  </motion.button>
                );
              })}
            </ul>
          </div>
        </motion.div>
      </div>
    </div>
  </div>
);
